import type { FaireProductEntity } from "../../entity_types/product";

export const p_ryyxrezupc: FaireProductEntity = {
  token: "p_ryyxrezupc",
  type: "product",
  name: "Metal Farm Animal Planter \u2013 Rustic Farmhouse Garden Decor Cute Cow Pig Sheep Dog Cat Planter",
  brandName: "Artisan Metal Art INC",
  imageUrl:
    "https://cdn.faire.com/fastly/952d843aef8d0fa1a5750bbae1658df3e835e305f6218c34133b60a641914f1d.jpeg",
  priceDollars: 0,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/f62d91c197eb185109ec50a2f048554b48a04537a5d83e182e507596979be5d8.png",
  weight: 1,
  dimensions: {
    width: 6,
    height: 6,
    depth: 4,
  },
  inStock: true,
};
